import { formatDate } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";

import { type DocumentStatusPillVariant } from "../components/StatusPill";
import { QUICK_SIGN_TEXT_WITH_LIGHTING_EMOJI } from "../DocumentsPage/constants";
import {
  type ApplicableWorkplacesDetails,
  getApplicableWorkplacesTextForRequirement,
} from "./getApplicableWorkplacesTextForRequirement";
import { truncateQualifications } from "./truncateQualifications";

export interface GetDocumentMetadataProps {
  timeToReviewInMinutes?: number;
  expiryDate?: Date;
  qualifications?: string[];
  applicableWorkplacesDetails?: ApplicableWorkplacesDetails;
  documentStatusPillVariant?: DocumentStatusPillVariant;
  maxNumberMetadataItems?: number;
  isQuickSign?: boolean;
}

export function getDocumentMetadata(props: GetDocumentMetadataProps) {
  const {
    timeToReviewInMinutes,
    expiryDate,
    qualifications,
    applicableWorkplacesDetails,
    documentStatusPillVariant,
    maxNumberMetadataItems,
    isQuickSign,
  } = props;

  const documentMetadataTextArray = [
    isDefined(timeToReviewInMinutes) ? `Takes ${timeToReviewInMinutes.toString()} mins` : undefined,
    isDefined(expiryDate) && documentStatusPillVariant === "expired"
      ? `Expired ${formatDate(expiryDate)}`
      : undefined,
    isDefined(applicableWorkplacesDetails)
      ? getApplicableWorkplacesTextForRequirement(applicableWorkplacesDetails)
      : undefined,
    isDefined(qualifications) ? truncateQualifications(qualifications) : undefined,
    isQuickSign ? QUICK_SIGN_TEXT_WITH_LIGHTING_EMOJI : undefined,
  ].filter((element) => isDefined(element));

  return isDefined(maxNumberMetadataItems)
    ? documentMetadataTextArray.slice(0, maxNumberMetadataItems)
    : documentMetadataTextArray;
}
